<template>
    <AdminPageInner v-if="course.id" :breadcrumbs="breadcrumbs">
        <template #heading>Bulk Record</template>

        <form v-if="form.records.length" @submit.prevent="submit" class="mt-6">
            <label class="inline-flex items-center">
                <Checkbox v-model="selectAll" :indeterminate.prop="indeterminate"/>
                <span class="inline-block ml-2">Select All</span>
            </label>

            <ul class="mt-6 sm:column-2 md:column-3 lg:column-4 space-y-4">
                <li v-for="record in form.records">
                    <label class="inline-flex items-center">
                        <Checkbox v-model="record.attended"/>
                        <span class="inline-block ml-2">{{ record.user_name }}</span>
                    </label>
                </li>
            </ul>

            <div class="flex justify-end mt-6">
                <SubmitButton
                    :submitting="form.processing"
                    :disabled="form.errors.any()">
                    Submit
                </SubmitButton>
            </div>
        </form>
        <div v-else class="border-2 border-dashed border-gray-200 p-4 text-center">
            <p>Nothing to display</p>
        </div>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import {CourseApplicationStatus as ApplicationStatus, CourseRecordStatus as RecordStatus} from "@/Lib/Enums";
import AdminPageInner from "@/Components/Layout/AdminPageInner";
import Checkbox from "@/Components/Form/Checkbox";
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    name: "CourseRecordsBulkPage",

    data() {
        return {
            ApplicationStatus,
            RecordStatus,
            course: {},
            form: this.$form(),

        };
    },

    provide() {
        return {
            form: this.form
        }
    },

    components: {
        AdminPageInner,
        Checkbox,
        SubmitButton,
    },

    methods: {
        setData({records, course}) {

            this.records = records;
            this.form.withData({records});

            if (course) {
                this.course = course;
            }
        },
        submit() {

            if (!confirm('Are you sure?')) {
                return;
            }

            if (this.form.processing) {
                return;
            }

            this.form.post(route('api.course-sessions.bulk-records', this.$route.params.courseSessionId))
                .then(() => {
                    this.$notify.success('Record created');
                    this.$router.push({
                        name: 'admin.courses.session-groups.sessions.records.index',
                        params: this.$route.params
                    });
                })
                .catch(() => {
                    this.$notify.warning('Something went wrong!')
                });
        },
    },

    computed: {
        selectAll: {
            get() {
                return this.form.records.length === this.form.records.filter(record => record.attended).length;
            },
            set(value) {
                this.form.records.forEach(record => record.attended = value)
            },
        },
        indeterminate() {
            const attended = this.form.records.filter(record => record.attended);

            return 0 < attended.length && attended.length < this.form.records.length;
        },
        breadcrumbs() {
            return [
                {
                    label: 'Admin', to: {name: 'admin'}
                },
                {
                    label: 'Courses', to: {name: 'admin.courses.index'}
                },
                {
                    label: `${this.course.title || 'Course'}`,
                    to: {name: 'admin.courses.show', params: {courseId: this.$route.params.courseId}}
                },
                {
                    label: `Session Groups`,
                    to: {name: 'admin.courses.session-groups.index', params: {courseId: this.$route.params.courseId}}
                },
                {
                    label: `Group`,
                    to: {
                        name: 'admin.courses.session-groups.show',
                        params: {
                            courseId: this.$route.params.courseId,
                            courseSessionGroupId: this.$route.params.courseSessionGroupId
                        }
                    }
                },
                //admin.courses.session-groups.sessions.records.index
                {
                    label: `Records`, to: {
                        name: 'admin.courses.session-groups.sessions.records.index',
                        params: this.$route.params
                    }
                },
                {
                    label: `Bulk`, to: {name: this.$route.name, params: this.$route.params}
                },
            ];
        },
    },

    watch: {},

    async beforeRouteEnter(to, from, next) {

        const data = await Promise.all([
            axios.get(route('api.course-sessions.bulk-records', to.params.courseSessionId)),
            axios.get(route('api.courses.show', to.params.courseId)),
        ]);

        next(vm => vm.setData({
            records: data[0].data,
            course: data[1].data
        }));
    }
};
</script>
